import { GithubLogo, LinkedinLogo } from '../ui/common/svgs';

const socials = [
  {
    svgComponent: GithubLogo,
    color: '#000000',
    url: 'https://github.com/david-dkp',
    socialName: 'GitHub',
  },
  {
    svgComponent: LinkedinLogo,
    color: '#0A66C1',
    url: 'https://www.linkedin.com/in/david-dekeuwer-1940a01b9/',
    socialName: 'LinkedIn',
  },
];

export default socials;
